import { SearchOutlined, PushpinOutlined } from "@ant-design/icons";
import { Button, Space, Input } from "antd";
import get from 'lodash/get';
import { STATE_ACTIVE, STATE_INACTIVE, STATE_CANCELLED, STATE_NOT_APPLICABLE } from './constants.js';

/**
 * Función que filtra búsquedas tanto en select simple como en select multiple
 * @param {String} inputValue El valor del input de búsqueda
 * @param {*} option Todas las opciones del select, una por una
 * @returns 
 */
function handleFilter(inputValue, option) {
  if (!inputValue) return true;
  if (!option.name) return;
  const val = inputValue.toString().toLowerCase()
  return (
    option.name.toString().toLowerCase().includes(val) ||
    (option.description !== undefined && option.description.toLowerCase().includes(val))
  );
};

/**
 * Método que permite el filtrado por texto de las columnas de una tabla a las que se agrega
 * @param {*} dataIndex Nombre de la columna
 * @returns 
 */
const GetColumnLiteralSearchProps = (dataIndex, lang) => {

  // Señal en selectedKeys para filtrar por campos vacíos.
  const EMPTY_FILTER_TOKEN = "__EMPTY__";

  const isEmptyValue = (val) =>
    val === null || val === undefined || val.toString().trim() === "";

  let searchInput;

  return ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {

      const handleConfirm = () => {
        if (!selectedKeys[0]) { setSelectedKeys([EMPTY_FILTER_TOKEN]); }
        confirm();
      };

      return (
        <div style={{ padding: 8 }}>
          <Input
            ref={node => { searchInput = node; }}
            placeholder={`Buscar`}
            value={selectedKeys[0] === EMPTY_FILTER_TOKEN ? "" : selectedKeys[0]}
            onChange={e => { setSelectedKeys(e.target.value ? [e.target.value] : []) }}
            onPressEnter={handleConfirm}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button type="primary" onClick={handleConfirm} icon={<SearchOutlined />} size="small" style={{ width: 90 }}>{ lang.handle("Buscar") }</Button>
            <Button onClick={() => { clearFilters(); confirm() }} size="small" style={{ width: 90 }}>{ lang.handle("Borrar") }</Button>
          </Space>
        </div>
      );
    },
    filterIcon: filtered => filtered ? <PushpinOutlined style={{ color: '#1890ff', fontSize: "1.3em" }} /> : <SearchOutlined />,
   onFilter: (value, record) => {

      if (value === EMPTY_FILTER_TOKEN) {
        const recordEmpty = isEmptyValue(get(record, dataIndex));
        const childrenEmpty = record.children
          ? record.children.some(child => isEmptyValue(get(child, dataIndex)))
          : false;
        return recordEmpty || childrenEmpty;
      }
      
      // Buscar en el propio registro
      const matchesRecord = get(record, dataIndex)
        ? get(record, dataIndex).toString().toLowerCase().includes(value.toLowerCase())
        : false;

      // Buscar en los hijos si existen
      const matchesChildren = record.children
        ? record.children.some(child =>
            get(child, dataIndex)
              ? get(child, dataIndex).toString().toLowerCase().includes(value.toLowerCase())
              : false
          )
        : false;

      return matchesRecord || matchesChildren;
    },
    onFilterDropdownOpenChange: visible => { if (visible) { setTimeout(() => searchInput.select(), 100); } },
  });
};

const getSubscriptionStateLabel = (state, lang) => {
  const stateMap = {
    [STATE_ACTIVE]: lang.handle('Activo'),
    [STATE_INACTIVE]: lang.handle('Lista para activación'),
    [STATE_CANCELLED]: lang.handle('Cancelado'),
    [STATE_NOT_APPLICABLE]: lang.handle('No procede'),
  };
  return stateMap[state] || state;
};

const getStatusLabel = (status, lang) => {
  const statusMap = {
    'Fabricado': lang.handle('Fabricado'),
    'Asignado': lang.handle('Asignado'),
    'Terminado': lang.handle('Terminado'),
    'Eliminado': lang.handle('Eliminado'),
  };
  return statusMap[status] || status;
};

const getRouterLabel = (router) => {
  if (!router) return '';
  return [router.modem_imei, router.modem_serial_number].filter(Boolean).join(' — ');
};

export { 
  GetColumnLiteralSearchProps, 
  handleFilter,
  getSubscriptionStateLabel, 
  getStatusLabel,
  getRouterLabel
}
